import { render } from "./Footer.vue?vue&type=template&id=6e1bfc54&scoped=true&lang=pug"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6e1bfc54&lang=scss&scoped=true"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1bfc54"]])

export default __exports__